import React, { useEffect, useState } from 'react';
import Api from '../../Api';
import * as Sentry from '@sentry/browser';
import { withAuth } from '../../hoc/Auth';
import { Wrapper, Container, Column } from '../../hoc/Layout';
import AuditLogsList from '../../Components/ComponentsOfAdministrator/AuditLogsList';
import AuditLogsFilters from '../../Components/ComponentsOfAdministrator/AuditLogsFilters';
import ResponsiveSidebarFilters from '../../Components/Utils/ResponsiveSidebarFilters';
import AdminFiltersToggle from '../../Components/ComponentsOfAdministrator/AdminFiltersToggle';
import Pagination from 'react-js-pagination';

import classes from './styles.module.css';

const AdminAudit = withAuth(({ token }) => {
    const [logs, setLogs] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(25);
    const [isLoading, setIsLoading] = useState(true);
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);

    const [filters, setFilters] = useState({
        actorId: null,
        action: null,
        entityType: null,
        startDate: null,
        endDate: null,
        search: null,
    });

    const [actions, setActions] = useState([]);
    const [entityTypes, setEntityTypes] = useState([]);
    const [admins, setAdmins] = useState([]);

    useEffect(() => {
        const api = new Api({ token });

        api.getAuditActions()
            .then((data) => {
                setActions(data && data.actions ? data.actions : []);
            })
            .catch((err) => {
                Sentry.captureException(err);
                setActions([]);
            });

        api.getAuditEntityTypes()
            .then((data) => {
                setEntityTypes(data && data.entityTypes ? data.entityTypes : []);
            })
            .catch((err) => {
                Sentry.captureException(err);
                setEntityTypes([]);
            });

        api.getAccountsList({ itemsPerPage: 1000, page: 1, filters: [] })
            .then((r) => {
                const all = Array.isArray(r) ? r : r && r.data ? r.data : [];
                setAdmins(all.filter((a) => a.privileges && a.privileges > 0));
            })
            .catch((err) => {
                Sentry.captureException(err);
                setAdmins([]);
            });
    }, [token]);

    useEffect(() => {
        loadLogs();
    }, [currentPage, filters]);

    function loadLogs() {
        setIsLoading(true);

        const api = new Api({ token });
        const params = {
            page: currentPage,
            itemsPerPage: itemsPerPage,
            actorId: filters.actorId || undefined,
            action: filters.action || undefined,
            entityType: filters.entityType || undefined,
            search: filters.search || undefined,
        };

        if (filters.startDate || filters.endDate) {
            params.dateRange = {};
            if (filters.startDate) params.dateRange.startDate = filters.startDate;
            if (filters.endDate) params.dateRange.endDate = filters.endDate;
        }

        Object.keys(params).forEach((key) => {
            if (params[key] === null || params[key] === '' || params[key] === undefined) {
                delete params[key];
            }
        });

        api.getAuditLogs(params)
            .then((data) => {
                setLogs(data.data || []);
                setTotalCount(data.count || 0);
                setIsLoading(false);
            })
            .catch((err) => {
                Sentry.captureException(err);
                console.error('Failed to load audit logs:', err);
                setLogs([]);
                setTotalCount(0);
                setIsLoading(false);
            });
    }

    function handleApplyFilters(newFilters) {
        setFilters(newFilters);
        setCurrentPage(1);
    }

    function handlePageChange(page) {
        setCurrentPage(page);
    }

    return (
        <Wrapper>
            <Container>
                <Column width="full">
                    <div className={classes.PageHeader}>
                        <h1 className={classes.PageTitle}>Журнал действий администраторов</h1>
                        <span className={classes.PageSubtitle}>
                            Все изменения в системе фиксируются и доступны для просмотра
                        </span>
                    </div>

                    <div className={classes.MobileFiltersToggle}>
                        <AdminFiltersToggle onClick={() => setIsFiltersOpen(true)} />
                    </div>

                    <ResponsiveSidebarFilters
                        title="Фильтры"
                        isOpen={isFiltersOpen}
                        onClose={() => setIsFiltersOpen(false)}
                    >
                        <AuditLogsFilters
                            actions={actions}
                            entityTypes={entityTypes}
                            admins={admins}
                            onApplyFilters={(newFilters) => {
                                handleApplyFilters(newFilters);
                                setIsFiltersOpen(false);
                            }}
                            isLoading={isLoading}
                        />
                    </ResponsiveSidebarFilters>

                    <div className={classes.Card}>
                        <AuditLogsList logs={logs} isLoading={isLoading} />

                        {totalCount > itemsPerPage && (
                            <div className={classes.PaginationWrap}>
                                <Pagination
                                    activePage={currentPage}
                                    itemsCountPerPage={itemsPerPage}
                                    totalItemsCount={totalCount}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                    itemClass={classes.PaginationItem}
                                    linkClass={classes.PaginationLink}
                                    activeClass={classes.PaginationActive}
                                />
                            </div>
                        )}
                    </div>

                    <div className={classes.Summary}>
                        Показано {logs.length} из {totalCount} записей
                    </div>
                </Column>
            </Container>
        </Wrapper>
    );
});

export default AdminAudit;



// WEBPACK FOOTER //
// ./src/PagesOfAdministrator/AdminAudit/index.js